// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/icons/play-control.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile_add_video_modal .modal2__container{
    width: 40%;
}

.profile_add_video_form_container{
    margin: 0 var(--space-x3);
}

.profile_add_video-new-content__media {
    position: relative;
    height: 400px;
    width: 100%;
    background: var(--primary-very-dark-color);
    border-radius: 8px;
    display: flex;
    align-items: center;
}

.profile_add_video-new-content__media img {
    height: 100%;
}

.profile_add_video-new-content__media-control {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.profile_add_video-new-content__media_video {
    width: 100%;
    height: 100%;
}

.profile_add_video-new-content__media-control__icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    position: absolute;
    background-repeat: no-repeat;
    width: calc(var(--space-x2)*2);
    height:calc(var(--space-x2)*2);
    background-size: contain;
}
.profile_add_video-new-content__media_control-mute {
    position: absolute;
    right: 2%;
    top: 90%;
}

.profile_add_video-new-content__media_control-mute__icon{
    color: white;
    font-size: var(--space-x2);
}

/* Progress */
.profile_add_video-new-content{
    margin: var(--space-half-quarter) 0 var(--space) 0;
}

.profile_add_video-new-content progress.profile_add_video-new-content__progress {
	display:flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: calc( var(--space) + var(--space-eighth) );
}

.profile_add_video-new-content progress.profile_add_video-new-content__progress::-webkit-progress-bar {
	height: calc( var(--space) + var(--space-eighth) );
	background-color: var(--body-background-color);
}

.profile_add_video-new-content progress.profile_add_video-new-content__progress::-webkit-progress-value {
	height:calc( var(--space) + var(--space-eighth) );
	background: var(--new-green-color);   
    opacity: 1;
}

.profile_add_video-new-content__progress:after {
	margin: 0;
	padding:0;
	position: absolute;
    font-size: var(--space-half-quarter);
    font-family: var(--secondary-font);
    font-weight: var(--font-medium);
    line-height: calc( var(--space-half-quarter) + var(--space-eighth) );
    color: var(--primary-very-dark-color);
}

.profile_add_video_button-submit{
    display: flex;
    justify-content: flex-end;
    margin: var(--space-and-half);
}

.profile_add_video_input-title-clip{
    margin: var(--space-x2) 0;
}

.profile_add_video_input-title-clip .input-field-label{
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
}

.profile_add_video_input-title-clip .input-field-input{
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
}

.profile_add_video-new-content__add-to-match{
    margin: 24px var(--space-x3);
}

.profile_add_video-new-content__add-to-match .hubicon-info {
    font-size: 18px;
    margin-right: 4px;
}

.profile_add_video-new-content__add-to-match .hubicon-info::before {
    color: var(--new-informative-banner-color);
}

.profile_add_video-new-content__add-to-match__message {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--new-informative-banner-bg-color);
    padding: 12px;
    border-radius: 4px;
    margin-top: 24px;
}

.profile_add_video-new-content__add-to-match__message .unblock-button{
    padding: 8px 12px;
}

.profile_add_video-new-content__add-to-match .baloa-names{
    color: var(--primary-very-dark-color);
}

.profile-add-video__tournament-match-info{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.profile-add-video__tournament_info{
    display: flex;
    align-items: center;
    background: var(--new-background-color);
    padding: 2px 4px;
    border-radius: 2px;
}

.profile-add-video__tournament_info .baloa-table{
    color: var(--primary-very-dark-color);
    width: 300px;
    white-space: nowrap; 
    overflow: hidden; 
    text-overflow: ellipsis; 
}

.profile-add-video__tournament_info__img{
    margin-right: 4px;
}

.profile-add-video__tournament_info__img img {
    width: 16px;
    height: 16px;
    border-radius: 50%;        
}

.profile-add-video__tournament_info__img .icon-ball {
    color: var(--white-color );
    font-size: 12px;
    border-radius: 50%;
    padding: 2px;    
}

.profile-add-video__match_date.baloa-table{
    color: var(--primary-very-dark-color);
    background: var(--new-background-color);
    padding: 2px 4px;
    border-radius: 2px;
}

.profile-add-video__tournament-match-data{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 14px;
}

.profile-add-video__tournament-match-data img{
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
}

.profile-add-video__tournament-match-data .icon-ball{
    color: var(--white-color );
    font-size: 20px;
    border-radius: 50%;
    padding: 2px;
    margin: 0 8px;
}

.profile-add-video__tournament-match-data__score{
    display: flex;
    align-items: center;
    width: 20%;
    justify-content: center;
}

.profile-add-video__tournament-match-data__label.baloa-table{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}

.profile-add-video__tournament-match-data__score__left {
    text-align: end;
}

.profile-add-video__tournament-match-data__score__right {
    text-align: start;
}

.profile-add-video__tournament-match-data__score__center{
    margin: 0 4px;
}

.profile-add-video__table-body__container{
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    border-radius: 8px; 
    padding: 12px 8px;
}

.profile-add-video__delete-match.baloa-username{
    color: var(--error-color);
    font-weight: var(--font-medium);
    margin-top: 16px;
    cursor: pointer;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .profile_add_video_modal .modal2__container{
        width: 100%;
        height: 100%;
        margin: 0;
        border-radius: 0px;
        max-height: none;
    }

    .profile_add_video_modal .modal2__content{
        height: 100%;
    }

    .profile_add_video_form_container {
        margin: 0 var(--space);
    }

    .profile_add_video-new-content__add-to-match {
        margin: 12px var(--space);
    }

    .profile_add_video-new-content__add-to-match__message{
        margin-top: 12px;
    }

    .profile_add_video_button-submit{
        margin: 16px 12px;
    }

    .profile_add_video_button-submit .button{
        width: 100%;
    }

    .profile_add_video-new-content__add-to-match__message .unblock-button{
        width: fit-content;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-add-video-modal/ProfileAddVideoModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yDAAkE;IAClE,kBAAkB;IAClB,4BAA4B;IAC5B,8BAA8B;IAC9B,8BAA8B;IAC9B,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA,aAAa;AACb;IACI,kDAAkD;AACtD;;AAEA;CACC,YAAY;IACT,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,kDAAkD;AACtD;;AAEA;CACC,kDAAkD;CAClD,8CAA8C;AAC/C;;AAEA;CACC,iDAAiD;CACjD,kCAAkC;IAC/B,UAAU;AACd;;AAEA;CACC,SAAS;CACT,SAAS;CACT,kBAAkB;IACf,oCAAoC;IACpC,kCAAkC;IAClC,+BAA+B;IAC/B,oEAAoE;IACpE,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,kDAAkD;AACtD;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wDAAwD;IACxD,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iDAAiD;IACjD,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;AACnB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,WAAW;QACX,YAAY;QACZ,SAAS;QACT,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".profile_add_video_modal .modal2__container{\n    width: 40%;\n}\n\n.profile_add_video_form_container{\n    margin: 0 var(--space-x3);\n}\n\n.profile_add_video-new-content__media {\n    position: relative;\n    height: 400px;\n    width: 100%;\n    background: var(--primary-very-dark-color);\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n}\n\n.profile_add_video-new-content__media img {\n    height: 100%;\n}\n\n.profile_add_video-new-content__media-control {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.profile_add_video-new-content__media_video {\n    width: 100%;\n    height: 100%;\n}\n\n.profile_add_video-new-content__media-control__icon {\n    background-image: url(\"../../../../assets/icons/play-control.png\");\n    position: absolute;\n    background-repeat: no-repeat;\n    width: calc(var(--space-x2)*2);\n    height:calc(var(--space-x2)*2);\n    background-size: contain;\n}\n.profile_add_video-new-content__media_control-mute {\n    position: absolute;\n    right: 2%;\n    top: 90%;\n}\n\n.profile_add_video-new-content__media_control-mute__icon{\n    color: white;\n    font-size: var(--space-x2);\n}\n\n/* Progress */\n.profile_add_video-new-content{\n    margin: var(--space-half-quarter) 0 var(--space) 0;\n}\n\n.profile_add_video-new-content progress.profile_add_video-new-content__progress {\n\tdisplay:flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    height: calc( var(--space) + var(--space-eighth) );\n}\n\n.profile_add_video-new-content progress.profile_add_video-new-content__progress::-webkit-progress-bar {\n\theight: calc( var(--space) + var(--space-eighth) );\n\tbackground-color: var(--body-background-color);\n}\n\n.profile_add_video-new-content progress.profile_add_video-new-content__progress::-webkit-progress-value {\n\theight:calc( var(--space) + var(--space-eighth) );\n\tbackground: var(--new-green-color);   \n    opacity: 1;\n}\n\n.profile_add_video-new-content__progress:after {\n\tmargin: 0;\n\tpadding:0;\n\tposition: absolute;\n    font-size: var(--space-half-quarter);\n    font-family: var(--secondary-font);\n    font-weight: var(--font-medium);\n    line-height: calc( var(--space-half-quarter) + var(--space-eighth) );\n    color: var(--primary-very-dark-color);\n}\n\n.profile_add_video_button-submit{\n    display: flex;\n    justify-content: flex-end;\n    margin: var(--space-and-half);\n}\n\n.profile_add_video_input-title-clip{\n    margin: var(--space-x2) 0;\n}\n\n.profile_add_video_input-title-clip .input-field-label{\n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n}\n\n.profile_add_video_input-title-clip .input-field-input{\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.profile_add_video-new-content__add-to-match{\n    margin: 24px var(--space-x3);\n}\n\n.profile_add_video-new-content__add-to-match .hubicon-info {\n    font-size: 18px;\n    margin-right: 4px;\n}\n\n.profile_add_video-new-content__add-to-match .hubicon-info::before {\n    color: var(--new-informative-banner-color);\n}\n\n.profile_add_video-new-content__add-to-match__message {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: var(--new-informative-banner-bg-color);\n    padding: 12px;\n    border-radius: 4px;\n    margin-top: 24px;\n}\n\n.profile_add_video-new-content__add-to-match__message .unblock-button{\n    padding: 8px 12px;\n}\n\n.profile_add_video-new-content__add-to-match .baloa-names{\n    color: var(--primary-very-dark-color);\n}\n\n.profile-add-video__tournament-match-info{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.profile-add-video__tournament_info{\n    display: flex;\n    align-items: center;\n    background: var(--new-background-color);\n    padding: 2px 4px;\n    border-radius: 2px;\n}\n\n.profile-add-video__tournament_info .baloa-table{\n    color: var(--primary-very-dark-color);\n    width: 300px;\n    white-space: nowrap; \n    overflow: hidden; \n    text-overflow: ellipsis; \n}\n\n.profile-add-video__tournament_info__img{\n    margin-right: 4px;\n}\n\n.profile-add-video__tournament_info__img img {\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;        \n}\n\n.profile-add-video__tournament_info__img .icon-ball {\n    color: var(--white-color );\n    font-size: 12px;\n    border-radius: 50%;\n    padding: 2px;    \n}\n\n.profile-add-video__match_date.baloa-table{\n    color: var(--primary-very-dark-color);\n    background: var(--new-background-color);\n    padding: 2px 4px;\n    border-radius: 2px;\n}\n\n.profile-add-video__tournament-match-data{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 14px;\n}\n\n.profile-add-video__tournament-match-data img{\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    margin: 0 8px;\n}\n\n.profile-add-video__tournament-match-data .icon-ball{\n    color: var(--white-color );\n    font-size: 20px;\n    border-radius: 50%;\n    padding: 2px;\n    margin: 0 8px;\n}\n\n.profile-add-video__tournament-match-data__score{\n    display: flex;\n    align-items: center;\n    width: 20%;\n    justify-content: center;\n}\n\n.profile-add-video__tournament-match-data__label.baloa-table{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.profile-add-video__tournament-match-data__score__left {\n    text-align: end;\n}\n\n.profile-add-video__tournament-match-data__score__right {\n    text-align: start;\n}\n\n.profile-add-video__tournament-match-data__score__center{\n    margin: 0 4px;\n}\n\n.profile-add-video__table-body__container{\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    border-radius: 8px; \n    padding: 12px 8px;\n}\n\n.profile-add-video__delete-match.baloa-username{\n    color: var(--error-color);\n    font-weight: var(--font-medium);\n    margin-top: 16px;\n    cursor: pointer;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .profile_add_video_modal .modal2__container{\n        width: 100%;\n        height: 100%;\n        margin: 0;\n        border-radius: 0px;\n        max-height: none;\n    }\n\n    .profile_add_video_modal .modal2__content{\n        height: 100%;\n    }\n\n    .profile_add_video_form_container {\n        margin: 0 var(--space);\n    }\n\n    .profile_add_video-new-content__add-to-match {\n        margin: 12px var(--space);\n    }\n\n    .profile_add_video-new-content__add-to-match__message{\n        margin-top: 12px;\n    }\n\n    .profile_add_video_button-submit{\n        margin: 16px 12px;\n    }\n\n    .profile_add_video_button-submit .button{\n        width: 100%;\n    }\n\n    .profile_add_video-new-content__add-to-match__message .unblock-button{\n        width: fit-content;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
